import { MORE_768_MEDIA_QUERY } from '../../../../consts/adaptive';

export const styles = {
    container: {
        display: 'flex',
        marginTop: 16,
        padding: [0, 0],
        flexWrap: 'wrap',
        justifyContent: 'left',
        backgroundColor: '#ffffff',
    },
    facilityItem: {
        display: 'flex',
        height: 100,
        alignItems: 'center',
        color: '#0078be',
        textAlign: 'center',
        justifyContent: 'center',
        margin: '0 5px',
    },
    iconWrapper: {
        width: 48,
        height: 48,
        marginRight: 20,
    },
    icon: {},
    label: {
        maxWidth: 220,
        fontSize: 13,
        textAlign: 'left',
        margin: 0,
    },

    [MORE_768_MEDIA_QUERY]: {
        facilityItem: {
            marginRight: 50,

            '&:last-child': {
                marginRight: 0,
            },
        },
    },
};

export type ComponentJSSClasses = typeof styles;
